import React from 'react';

import { Styled } from './About.styles';
import Title from '../../../components/UI/Title';
import PageBody from '../../../components/UI/PageBody';
import styled from 'styled-components';
import { PageHeader } from '../components/PageHeader';
import { Page } from '../components/Page';
import { LogoutButton, NavigationButton } from '../components/NavigationButton';

const Text = styled.div`
  h2 {
    font-weight: normal;
    font-size: 18px;
  }
  p {
    text-indent: 1.5em;
  }
  padding: 16px;

  ul {
    list-style: none;
  }
`;

const features = [
  'Карта с указанием транспортных средств',
  'Видео для выбора и просмотра онлайн-видео с транспортных средств',
  'Проведение билетного контроля с отчетами по результатам проверок',
  'Справочники с данными о ТС, маршрутах и сотрудниках.',
];

export const About: React.FC = () => (
  <Page
    title="О платформе"
    primaryButtonNode={<NavigationButton />}
    actionButton={<LogoutButton />}
  >
    <Text>
      <h2>Универсальная мультисервисная платформа</h2>
      <p>
        Программное обеспечение платформы позволяет осуществлять анализ качества
        транспортного обслуживания населения, повышать экономическую
        эффективность пассажирских перевозок с использованием инновационных
        технологий взаимодействия с оборудованием транспортных средств и
        обрабатывать информацию, поступающую с транспортных средств. Мобильное
        приложение предоставляет возможность оперативного просмотра он-лайн
        видео, а также проведения билетного контроля с мобильных устройств.
        Доступ пользователя к приложению обеспечивается согласно ролевой модели.
        Отображение пользователю осуществляется в интерфейсе приложения с
        управлением данными следующих подсистем, доступных в Меню УМП:
      </p>
      <ul>
        {features.map((feature) => (
          <li key={feature}>- {feature}</li>
        ))}
      </ul>
    </Text>
  </Page>
);
